module.exports = __webpack_public_path__ + "img/honor2.0.1.0_202602021803.png";